export default "__VITE_ASSET__9H$Uvcb1__"